import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum LogEntryFields {
    TYPE = 'type',
    OBJECT_TYPE = 'objectType',
    OBJECT = 'object',
    AUTHOR_TYPE = 'authorType',
    AUTHOR = 'author',
    PAYLOAD = 'payload',
    REPLIES_TO = 'repliesTo',
    STICKY = 'sticky',
    SORTING_DATE = 'sortingDate',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
    BACKUP_REF = '_backupRef',
    MENTIONS = 'mentions',
    TAGS = 'tags',
}

export namespace LogEntryFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<LogEntryFields, Data> = {
        [LogEntryFields.TYPE]: {
            text: 'Art des Protokolleintrags',
        },
        [LogEntryFields.OBJECT]: {
            text: 'Zugewiesenes Profil',
            readOnly: true,
        },
        [LogEntryFields.OBJECT_TYPE]: {
            text: 'Art des zugewiesenen Profils',
            readOnly: true,
        },
        [LogEntryFields.AUTHOR]: {
            text: 'Profil des Autors',
            readOnly: true,
        },
        [LogEntryFields.AUTHOR_TYPE]: {
            text: 'Art des Autoren-Profils',
            readOnly: true,
        },
        [LogEntryFields.PAYLOAD]: {
            text: 'Inhalt',
        },
        [LogEntryFields.REPLIES_TO]: {
            text: 'Antwort auf',
            readOnly: true,
        },
        [LogEntryFields.STICKY]: {
            text: 'Angeheftet',
        },
        [LogEntryFields.SORTING_DATE]: {
            text: 'Sortierdatum',
            readOnly: true,
        },
        [LogEntryFields.CREATED_AT]: {
            text: 'Erstellungsdatum',
            readOnly: true,
        },
        [LogEntryFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
            readOnly: true,
        },
        [LogEntryFields.BACKUP_REF]: {
            text: 'Backup Referenz',
            readOnly: true,
        },
        [LogEntryFields.MENTIONS]: {
            text: 'Erwähnungen',
        },
        [LogEntryFields.TAGS]: {
            text: 'Tags',
        },
    };

    export const Items = mapRecordToItems(Record);
}
